var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tw-rounded tw-w-full tw-overflow-hidden tw-bg-infinity-card-background tw-border tw-border-solid tw-border-infinity-card-border",class:_vm.data.staticClass || ''},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }